import { Flex } from '@chakra-ui/react'
import { FaUser } from 'react-icons/fa'
import { iDiscursiva } from '../../../..'
import { ModalBase } from '../../../../../../../components/ModalBase'
import { parseJwt } from '../../../../../../../services/token'
import { ComentariosContainer } from '../../../../styles'
import { Container } from './styles'

interface iModal {
  comentarios: iDiscursiva[]
  isOpen: boolean
  onRequestClose: () => void
}

export const ModalComentarios: React.FC<iModal> = ({ comentarios, isOpen, onRequestClose }) => {
  function ObterNomeTipoAvaliador(tipo: number): string {
    switch (tipo) {
      case 0:
        return 'Autoavaliação'
      case 1:
        return 'Gestor'
      case 2:
        return 'Par'
      case 3:
        return 'Liderado'
      case 4:
        return 'Outro'
      case 5:
        return 'Gestor'
      case 6:
        return 'Alta liderança'
      default:
        return 'Não indetificado'
    }
  }
  return (
        <ModalBase isOpen={isOpen} onClose={onRequestClose} Titulo={`Comentários: ${comentarios.length}`} Width='50rem'>
            <Container>
                <Flex flexDir={'column'} gap='1rem'>
                    {
                        comentarios.map((e, i) => {
                          return (
                                <ComentariosContainer key={i}>
                                    <strong>{e.titulo}</strong>
                                    <span>{e.texto}</span>
                                     {parseJwt().eid === 'd6856640-fe74-4387-a2ce-f4702ab6c1ab' && <span style={{ fontSize: '10px', fontWeight: 'bold', color: 'var(--c7)' }}
                          ><FaUser /> {ObterNomeTipoAvaliador(e.tipoAvaliador)}</span>}
                                </ComentariosContainer>
                          )
                        })
                    }
                </Flex>
            </Container>
        </ModalBase>
  )
}
